import PropTypes from 'prop-types';
import { getContext } from 'recompose';

export const getAlertContext = getContext({
  showAlert: PropTypes.func,
});
